module.exports = __webpack_public_path__ + "static/media/31.83936aa5.jpg";